import api from "../../../services/api";

export const fetchEcommMultiChannel = async (period: number) => {
  const response = await api.get("/api/shopify/managerial/multi_channel", {
    params: { period },
  });
  return response.data;
};
